<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_18992_12006)">
      <path
        d="M7.34375 11.875V15.9801C7.34375 16.3237 7.7012 16.5505 8.01209 16.4042L9.80041 15.5627C9.92682 15.5032 10.0732 15.5032 10.1996 15.5627L11.9879 16.4042C12.2988 16.5505 12.6562 16.3237 12.6562 15.9801V11.875M14.5312 8.125C14.5312 10.6275 12.5025 12.6562 10 12.6562C7.49746 12.6562 5.46875 10.6275 5.46875 8.125C5.46875 5.62246 7.49746 3.59375 10 3.59375C12.5025 3.59375 14.5312 5.62246 14.5312 8.125Z"
        stroke="currentColor" 
        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_18992_12006">
        <rect width="15" height="15" fill="white" style="fill:white;fill-opacity:1;" transform="translate(2.5 2.5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'WinnerIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>